module.exports = __webpack_public_path__ + "static/media/item_9_1_comp.bd4f54a6.png";